import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'app-pchataudio',
  templateUrl: './pchataudio.component.html',
  styleUrls: ['./pchataudio.component.sass']
})
export class PchataudioComponent implements OnInit {
  @Input('res') response: object;
  @Input('className') className: string;
  constructor() { }

  ngOnInit(): void {
   
  }

}
